import * as React from "react";
const SvgDotsVertical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M42 35v.01M42 42v.01M42 49v.01M42 36a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    />
  </svg>
);
export default SvgDotsVertical;
